<template>
  <div class="tab-wrap">
    <div
        v-for="(tab, index) in tabs"
        :key="tab.code"
        :class="['tab-item', active === index ? 'active': '']"
        @click="changeTab(tab, index)"
    >
      <div class="tab-icon-wrap">
        <i :class="['tab-icon', tab.code]"></i>
      </div>
      <p class="tab-name">{{ tab.tabName }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: ['comic', 'genres', 'discover', 'chat', 'profile'],
      active: 0,
    };
  },
  watch: {
    '$route': {
      handler(val) {
        this.handleActive(val);
      },
      immediate: true,
    },
  },
  computed: {
    tabs() {
      return this.list.map((tab) => ({
        tabName: tab[0].toLocaleUpperCase() + tab.slice(1),
        code: tab,
        path: `/app/${tab}`,
      }));
    },
  },
  created() {
  },
  methods: {
    handleActive(route) {
      let i = this.list.findIndex((item) => item === route.name.toLocaleLowerCase());
      i = Math.max(i, 0);
      this.active = i;
    },
    changeTab(tab, index) {
      if (index === this.active) return;
      this.active = index;
      this.$router.replace(tab.path);
    },
  },
};
</script>

<style lang="less" scoped>
.tab-wrap {
    height: 80px;
    .border-1px('top', rgb(30, 30, 30));
    display: flex;
    .tab-item {
        flex: 1;
        .flex-column-center();
        .tab-icon-wrap {
          width: 100%;
          height: 32px;
          border-radius: 34px;
          .flex-center();
          .tab-icon {
            .iconMixin({
              background-position: center center;
            });

            &.discover {
              background-image: url('~@/assets/images/common/tab/icon-discover.png');
            }
            &.genres {
              background-image: url('~@/assets/images/common/tab/icon-genres.png');
            }
            &.chat {
              background-image: url('~@/assets/images/common/tab/icon-chat.png');
            }
            &.comic {
              background-image: url('~@/assets/images/common/tab/icon-comic.png');
            }
            &.profile {
              background-image: url('~@/assets/images/common/tab/icon-profile.png');
            }
          }
        }
        .tab-name {
          font-size: @fontSmall;
          font-weight: 700;
          color: @gray;
          text-align: center;
        }
        &.active {
          .tab-icon-wrap {
            .transparent-theme(.15);
          }
          .tab-icon {
            &.discover {
              background-image: url('~@/assets/images/common/tab/icon-discover-active.png');
            }
            &.genres {
              background-image: url('~@/assets/images/common/tab/icon-genres-active.png');
            }
            &.chat {
              background-image: url('~@/assets/images/common/tab/icon-chat-active.png');
            }
            &.comic {
              background-image: url('~@/assets/images/common/tab/icon-comic-active.png');
            }
            &.profile {
              background-image: url('~@/assets/images/common/tab/icon-profile-active.png');
            }
          }
          .tab-name {
            color: @theme;
            font-weight: 700;
          }
        }
    }

}
</style>
